'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = getNearby;

var _haversine = require('haversine');

var _haversine2 = _interopRequireDefault(_haversine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getValidLocations = function getValidLocations(locations) {
  return locations.filter(function (_ref) {
    var lat = _ref.lat,
        lng = _ref.lng;

    return lat && lng;
  });
};

function getNearby(center, locations) {
  var getDistance = function getDistance(target) {
    return (0, _haversine2.default)({
      latitude: center.lat,
      longitude: center.lat
    }, {
      latitude: target.lat,
      longitude: target.lat
    }, {
      //unit: 'meter',
    });
  };

  return getValidLocations(locations).map(function (location) {
    return (0, _extends3.default)({}, location, {
      distance: getDistance(location)
    });
  }).sort(function (a, b) {
    return a.distance - b.distance;
  });
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/utils/getNearby/getNearby.js
// module id = 1309
// module chunks = 0